
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrderUpdateResponse} from './OrderUpdateResponse';

/**
 * OrderUpdateRequest struct
 */
class OrderUpdateRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {number=} orderId
   * @param {string=} clientOrderId
   * @param {number=} newPrice
   * @param {number=} newStopPrice
   * @param {number=} newTakeProfit
   * @param {!boolean=} newTakeProfitReset
   * @param {number=} newStopLoss
   * @param {!boolean=} newStopLossReset
   * @param {number=} newAmount
   * @param {Date=} newExpiration
   * @param {!boolean=} newExpirationReset
   * @param {string=} newComment
   * @param {number=} newMagic
   * @param {!boolean=} newMagicReset
   * @constructor
   */
  constructor (parent = new Request(), orderId = null, clientOrderId = null, newPrice = null, newStopPrice = null, newTakeProfit = null, newTakeProfitReset = false, newStopLoss = null, newStopLossReset = false, newAmount = null, newExpiration = null, newExpirationReset = false, newComment = null, newMagic = null, newMagicReset = false) {
    super()
    super.copy(parent)
    this.OrderId = orderId
    this.ClientOrderId = clientOrderId
    this.NewPrice = newPrice
    this.NewStopPrice = newStopPrice
    this.NewTakeProfit = newTakeProfit
    this.NewTakeProfitReset = newTakeProfitReset
    this.NewStopLoss = newStopLoss
    this.NewStopLossReset = newStopLossReset
    this.NewAmount = newAmount
    this.NewExpiration = newExpiration
    this.NewExpirationReset = newExpirationReset
    this.NewComment = newComment
    this.NewMagic = newMagic
    this.NewMagicReset = newMagicReset
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderUpdateRequest}
   * @param {!OrderUpdateRequest} other Other struct
   * @returns {!OrderUpdateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.ClientOrderId != null) {
      this.ClientOrderId = other.ClientOrderId
    } else {
      this.ClientOrderId = null
    }
    if (other.NewPrice != null) {
      this.NewPrice = other.NewPrice
    } else {
      this.NewPrice = null
    }
    if (other.NewStopPrice != null) {
      this.NewStopPrice = other.NewStopPrice
    } else {
      this.NewStopPrice = null
    }
    if (other.NewTakeProfit != null) {
      this.NewTakeProfit = other.NewTakeProfit
    } else {
      this.NewTakeProfit = null
    }
    if (other.NewTakeProfitReset != null) {
      this.NewTakeProfitReset = other.NewTakeProfitReset
    } else {
      this.NewTakeProfitReset = null
    }
    if (other.NewStopLoss != null) {
      this.NewStopLoss = other.NewStopLoss
    } else {
      this.NewStopLoss = null
    }
    if (other.NewStopLossReset != null) {
      this.NewStopLossReset = other.NewStopLossReset
    } else {
      this.NewStopLossReset = null
    }
    if (other.NewAmount != null) {
      this.NewAmount = other.NewAmount
    } else {
      this.NewAmount = null
    }
    if (other.NewExpiration != null) {
      if (other.NewExpiration instanceof Date) {
        this.NewExpiration = new Date(other.NewExpiration.getTime())
      } else {
        this.NewExpiration = new Date(Math.round(other.NewExpiration / 1000000))
      }
    } else {
      this.NewExpiration = null
    }
    if (other.NewExpirationReset != null) {
      this.NewExpirationReset = other.NewExpirationReset
    } else {
      this.NewExpirationReset = null
    }
    if (other.NewComment != null) {
      this.NewComment = other.NewComment
    } else {
      this.NewComment = null
    }
    if (other.NewMagic != null) {
      this.NewMagic = other.NewMagic
    } else {
      this.NewMagic = null
    }
    if (other.NewMagicReset != null) {
      this.NewMagicReset = other.NewMagicReset
    } else {
      this.NewMagicReset = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderUpdateRequest}
   * @returns {!OrderUpdateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderUpdateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderUpdateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderUpdateRequest}
   * @param {!OrderUpdateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderUpdateRequest)) {
      throw new TypeError('Instance of OrderUpdateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderUpdateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      ClientOrderId: ((this.ClientOrderId != null) ? this.ClientOrderId : null),
      NewPrice: ((this.NewPrice != null) ? this.NewPrice : null),
      NewStopPrice: ((this.NewStopPrice != null) ? this.NewStopPrice : null),
      NewTakeProfit: ((this.NewTakeProfit != null) ? this.NewTakeProfit : null),
      NewTakeProfitReset: ((this.NewTakeProfitReset != null) ? this.NewTakeProfitReset : null),
      NewStopLoss: ((this.NewStopLoss != null) ? this.NewStopLoss : null),
      NewStopLossReset: ((this.NewStopLossReset != null) ? this.NewStopLossReset : null),
      NewAmount: ((this.NewAmount != null) ? this.NewAmount : null),
      NewExpiration: ((this.NewExpiration != null) ? (this.NewExpiration.getTime() * 1000000) : null),
      NewExpirationReset: ((this.NewExpirationReset != null) ? this.NewExpirationReset : null),
      NewComment: ((this.NewComment != null) ? this.NewComment : null),
      NewMagic: ((this.NewMagic != null) ? this.NewMagic : null),
      NewMagicReset: ((this.NewMagicReset != null) ? this.NewMagicReset : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderUpdateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderUpdateRequest} other Object value
   * @returns {!OrderUpdateRequest} Created struct
   */
  static fromObject (other) {
    return new OrderUpdateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderUpdateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderUpdateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderUpdateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5090
  }
}

export { OrderUpdateRequest };

/**
 * Fast Binary Encoding OrderUpdateRequest field model
 */
class FieldModelOrderUpdateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.OrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ClientOrderId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.NewPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ClientOrderId.fbeOffset + this.ClientOrderId.fbeSize), buffer, this.ClientOrderId.fbeOffset + this.ClientOrderId.fbeSize)
    this.NewStopPrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewPrice.fbeOffset + this.NewPrice.fbeSize), buffer, this.NewPrice.fbeOffset + this.NewPrice.fbeSize)
    this.NewTakeProfit = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewStopPrice.fbeOffset + this.NewStopPrice.fbeSize), buffer, this.NewStopPrice.fbeOffset + this.NewStopPrice.fbeSize)
    this.NewTakeProfitReset = new fbe.FieldModelBool(buffer, this.NewTakeProfit.fbeOffset + this.NewTakeProfit.fbeSize)
    this.NewStopLoss = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewTakeProfitReset.fbeOffset + this.NewTakeProfitReset.fbeSize), buffer, this.NewTakeProfitReset.fbeOffset + this.NewTakeProfitReset.fbeSize)
    this.NewStopLossReset = new fbe.FieldModelBool(buffer, this.NewStopLoss.fbeOffset + this.NewStopLoss.fbeSize)
    this.NewAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.NewStopLossReset.fbeOffset + this.NewStopLossReset.fbeSize), buffer, this.NewStopLossReset.fbeOffset + this.NewStopLossReset.fbeSize)
    this.NewExpiration = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.NewAmount.fbeOffset + this.NewAmount.fbeSize), buffer, this.NewAmount.fbeOffset + this.NewAmount.fbeSize)
    this.NewExpirationReset = new fbe.FieldModelBool(buffer, this.NewExpiration.fbeOffset + this.NewExpiration.fbeSize)
    this.NewComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewExpirationReset.fbeOffset + this.NewExpirationReset.fbeSize), buffer, this.NewExpirationReset.fbeOffset + this.NewExpirationReset.fbeSize)
    this.NewMagic = new fbe.FieldModelOptional(new fbe.FieldModelInt32(buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize), buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize)
    this.NewMagicReset = new fbe.FieldModelBool(buffer, this.NewMagic.fbeOffset + this.NewMagic.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.OrderId.fbeSize + this.ClientOrderId.fbeSize + this.NewPrice.fbeSize + this.NewStopPrice.fbeSize + this.NewTakeProfit.fbeSize + this.NewTakeProfitReset.fbeSize + this.NewStopLoss.fbeSize + this.NewStopLossReset.fbeSize + this.NewAmount.fbeSize + this.NewExpiration.fbeSize + this.NewExpirationReset.fbeSize + this.NewComment.fbeSize + this.NewMagic.fbeSize + this.NewMagicReset.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.OrderId.fbeExtra + this.ClientOrderId.fbeExtra + this.NewPrice.fbeExtra + this.NewStopPrice.fbeExtra + this.NewTakeProfit.fbeExtra + this.NewTakeProfitReset.fbeExtra + this.NewStopLoss.fbeExtra + this.NewStopLossReset.fbeExtra + this.NewAmount.fbeExtra + this.NewExpiration.fbeExtra + this.NewExpirationReset.fbeExtra + this.NewComment.fbeExtra + this.NewMagic.fbeExtra + this.NewMagicReset.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderUpdateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5090
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPrice.fbeSize

    if ((fbeCurrentSize + this.NewStopPrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewStopPrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopPrice.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfit.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTakeProfit.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfit.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfitReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTakeProfitReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.NewStopLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewStopLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLoss.fbeSize

    if ((fbeCurrentSize + this.NewStopLossReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewStopLossReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLossReset.fbeSize

    if ((fbeCurrentSize + this.NewAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAmount.fbeSize

    if ((fbeCurrentSize + this.NewExpiration.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewExpiration.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewExpiration.fbeSize

    if ((fbeCurrentSize + this.NewExpirationReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewExpirationReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewExpirationReset.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewMagic.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMagic.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagic.fbeSize

    if ((fbeCurrentSize + this.NewMagicReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMagicReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagicReset.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue Default value, defaults is new OrderUpdateRequest()
   * @returns {!OrderUpdateRequest} OrderUpdateRequest value
   */
  get (fbeValue = new OrderUpdateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue OrderUpdateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.ClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.ClientOrderId = this.ClientOrderId.get()
    } else {
      fbeValue.ClientOrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientOrderId.fbeSize

    if ((fbeCurrentSize + this.NewPrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewPrice = this.NewPrice.get()
    } else {
      fbeValue.NewPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPrice.fbeSize

    if ((fbeCurrentSize + this.NewStopPrice.fbeSize) <= fbeStructSize) {
      fbeValue.NewStopPrice = this.NewStopPrice.get()
    } else {
      fbeValue.NewStopPrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopPrice.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfit.fbeSize) <= fbeStructSize) {
      fbeValue.NewTakeProfit = this.NewTakeProfit.get()
    } else {
      fbeValue.NewTakeProfit = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfit.fbeSize

    if ((fbeCurrentSize + this.NewTakeProfitReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewTakeProfitReset = this.NewTakeProfitReset.get()
    } else {
      fbeValue.NewTakeProfitReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTakeProfitReset.fbeSize

    if ((fbeCurrentSize + this.NewStopLoss.fbeSize) <= fbeStructSize) {
      fbeValue.NewStopLoss = this.NewStopLoss.get()
    } else {
      fbeValue.NewStopLoss = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLoss.fbeSize

    if ((fbeCurrentSize + this.NewStopLossReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewStopLossReset = this.NewStopLossReset.get()
    } else {
      fbeValue.NewStopLossReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewStopLossReset.fbeSize

    if ((fbeCurrentSize + this.NewAmount.fbeSize) <= fbeStructSize) {
      fbeValue.NewAmount = this.NewAmount.get()
    } else {
      fbeValue.NewAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAmount.fbeSize

    if ((fbeCurrentSize + this.NewExpiration.fbeSize) <= fbeStructSize) {
      fbeValue.NewExpiration = this.NewExpiration.get()
    } else {
      fbeValue.NewExpiration = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewExpiration.fbeSize

    if ((fbeCurrentSize + this.NewExpirationReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewExpirationReset = this.NewExpirationReset.get()
    } else {
      fbeValue.NewExpirationReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewExpirationReset.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) <= fbeStructSize) {
      fbeValue.NewComment = this.NewComment.get()
    } else {
      fbeValue.NewComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewMagic.fbeSize) <= fbeStructSize) {
      fbeValue.NewMagic = this.NewMagic.get()
    } else {
      fbeValue.NewMagic = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagic.fbeSize

    if ((fbeCurrentSize + this.NewMagicReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewMagicReset = this.NewMagicReset.get()
    } else {
      fbeValue.NewMagicReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMagicReset.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue OrderUpdateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderUpdateRequest}
   * @param {OrderUpdateRequest} fbeValue OrderUpdateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.OrderId.set(fbeValue.OrderId)
    this.ClientOrderId.set(fbeValue.ClientOrderId)
    this.NewPrice.set(fbeValue.NewPrice)
    this.NewStopPrice.set(fbeValue.NewStopPrice)
    this.NewTakeProfit.set(fbeValue.NewTakeProfit)
    this.NewTakeProfitReset.set(fbeValue.NewTakeProfitReset)
    this.NewStopLoss.set(fbeValue.NewStopLoss)
    this.NewStopLossReset.set(fbeValue.NewStopLossReset)
    this.NewAmount.set(fbeValue.NewAmount)
    this.NewExpiration.set(fbeValue.NewExpiration)
    this.NewExpirationReset.set(fbeValue.NewExpirationReset)
    this.NewComment.set(fbeValue.NewComment)
    this.NewMagic.set(fbeValue.NewMagic)
    this.NewMagicReset.set(fbeValue.NewMagicReset)
  }
}

export { FieldModelOrderUpdateRequest };

/**
 * Fast Binary Encoding OrderUpdateRequest model
 */
class OrderUpdateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderUpdateRequest(this.buffer, 4)
  }

  /**
   * Get the OrderUpdateRequest model
   * @this {!OrderUpdateRequestModel}
   * @returns {!FieldModelOrderUpdateRequest} model OrderUpdateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderUpdateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderUpdateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderUpdateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderUpdateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!OrderUpdateRequest} value OrderUpdateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!OrderUpdateRequest} value OrderUpdateRequest value, defaults is new OrderUpdateRequest()
   * @return {!object} Deserialized OrderUpdateRequest value and its size
   */
  deserialize (value = new OrderUpdateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderUpdateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderUpdateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!number} prev Previous OrderUpdateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderUpdateRequestModel };
OrderUpdateRequest.__has_response = true;
OrderUpdateRequest.__response_class = OrderUpdateResponse;
